// extracted by mini-css-extract-plugin
export default {"wrapper":"welcome_wrapper__kZdMK","card":"welcome_card__tgwr2","thumbnail":"welcome_thumbnail__zO0W2","overlay":"welcome_overlay__NGbHW","badge":"welcome_badge__9tJO8"};